function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5 0.0148926C2.23858 0.0148926 0 2.25347 0 5.01489V43.0149C0 45.7763 2.23858 48.0149 5 48.0149H24.2775L24.2775 0.0148926H5Z",
  fill: "#18A43B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2775 0.0148926V22.0156L48 22.0156V5.01489C48 2.25347 45.7614 0.0148926 43 0.0148926H26.2775Z",
  fill: "#18A43B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 24.0156L26.2775 24.0156V48.0149H43C45.7614 48.0149 48 45.7763 48 43.0149V24.0156Z",
  fill: "#18A43B"
});

var Svg3AActive = function Svg3AActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg3AActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/3a_active.50038c71.svg";
export { ForwardRef as ReactComponent };